import axios from 'axios'
import { Auth } from 'aws-amplify'

const client = axios.create({ baseURL: process.env.VUE_APP_BILLING_API || process.env.VUE_APP_ROOT_API, timeout: 30000 })
export const supportTopics = ['Account', 'Technical Problem', 'Privacy & Security', 'Billing', 'Affiliate', 'Feature Request', 'Something Else']
export function supportRequestId() {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] % 16) + 64
  bytes[8] = (bytes[8] % 64) + 128
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
async function admin(method, path, data, params) {
  const session = await Auth.currentSession()
  const response = await client.request({
    method,
    url: `/admin/support/messages${path}`,
    data,
    params,
    headers: { Authorization: session.getAccessToken().getJwtToken() },
  })

  return response.data
}
export default {
  async send(data, id) {
    const response = await client.post('/support/messages', data, { headers: { 'Idempotency-Key': id } })

    return response.data
  },
  list: params => admin('get', '', undefined, params),
  detail: id => admin('get', `/${id}`),
  update: (id, status) => admin('patch', `/${id}`, { status }),
}
